/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateDiscountPayload = {
    validUntil?: string | null;
    categoryId: number;
    discountType: CreateDiscountPayload.discountType;
    value: string;
    note?: string | null;
};
export namespace CreateDiscountPayload {
    export enum discountType {
        PERCENTAGE = 'percentage',
        FIXED = 'fixed',
    }
}

